"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1898],{

/***/ 6834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ nullable; },
/* harmony export */   "FX": function() { return /* binding */ getAddStringContext; },
/* harmony export */   "n1": function() { return /* binding */ addCustomAttributes; },
/* harmony export */   "uR": function() { return /* binding */ numeric; }
/* harmony export */ });
/* harmony import */ var _util_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4155);
/* harmony import */ var _config_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3807);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



var hasOwnProp = Object.prototype.hasOwnProperty;
var MAX_ATTRIBUTES = 64;
function nullable(val, fn, comma) {
  return val || val === 0 || val === '' ? fn(val) + (comma ? ',' : '') : '!';
}
function numeric(n, noDefault) {
  if (noDefault) {
    return Math.floor(n).toString(36);
  }
  return n === undefined || n === 0 ? '' : Math.floor(n).toString(36);
}
function getAddStringContext(agentIdentifier) {
  let stringTableIdx = 0;
  const stringTable = Object.prototype.hasOwnProperty.call(Object, 'create') ? Object.create(null) : {};
  const obfuscator = (0,_config_runtime__WEBPACK_IMPORTED_MODULE_1__/* .getRuntime */ .O)(agentIdentifier).obfuscator;
  return addString;
  function addString(str) {
    if (typeof str === 'undefined' || str === '') return '';
    str = obfuscator.obfuscateString(String(str));
    if (hasOwnProp.call(stringTable, str)) {
      return numeric(stringTable[str], true);
    } else {
      stringTable[str] = stringTableIdx++;
      return quoteString(str);
    }
  }
}
function addCustomAttributes(attrs, addString) {
  var attrParts = [];
  Object.entries(attrs || {}).forEach(([key, val]) => {
    if (attrParts.length >= MAX_ATTRIBUTES) return;
    var type = 5;
    var serializedValue;
    // add key to string table first
    key = addString(key);
    switch (typeof val) {
      case 'object':
        if (val) {
          // serialize objects to strings
          serializedValue = addString((0,_util_stringify__WEBPACK_IMPORTED_MODULE_0__/* .stringify */ .P)(val));
        } else {
          // null attribute type
          type = 9;
        }
        break;
      case 'number':
        type = 6;
        // make sure numbers contain a `.` so they are parsed as doubles
        serializedValue = val % 1 ? val : val + '.';
        break;
      case 'boolean':
        type = val ? 7 : 8;
        break;
      case 'undefined':
        // we treat undefined as a null attribute (since dirac does not have a concept of undefined)
        type = 9;
        break;
      default:
        serializedValue = addString(val);
    }
    attrParts.push([type, key + (serializedValue ? ',' + serializedValue : '')]);
  });
  return attrParts;
}
var escapable = /([,\\;])/g;
function quoteString(str) {
  return "'" + str.replace(escapable, '\\$1');
}

/***/ }),

/***/ 1731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ isPureObject; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Tests a passed object to see if it is a pure object or not. All non-primatives in JS
 * are technically objects and would pass a `typeof` check.
 * @param {*} obj Input object to be tested
**/
function isPureObject(obj) {
  return obj?.constructor === {}.constructor;
}

/***/ }),

/***/ 4089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aggregate": function() { return /* binding */ Aggregate; }
});

// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/register-handler.js
var register_handler = __webpack_require__(5992);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/stringify.js
var stringify = __webpack_require__(4155);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/handle.js
var handle = __webpack_require__(5300);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/deny-list/deny-list.js
var deny_list = __webpack_require__(4741);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/ajax/constants.js
var constants = __webpack_require__(513);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/loaders/features/features.js
var features = __webpack_require__(4663);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/aggregate-base.js + 7 modules
var aggregate_base = __webpack_require__(7410);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/type-check.js
var type_check = __webpack_require__(1731);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/ajax/aggregate/gql.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */


/**
 * @typedef {object} GQLMetadata
 * @property {string} operationName Name of the operation
 * @property {string} operationType Type of the operation
 * @property {string} operationFramework Framework responsible for the operation
 */

/**
 * Parses and returns the graphql metadata from a network request. If the network
 * request is not a graphql call, undefined will be returned.
 * @param {object|string} body Ajax request body
 * @param {string} query Ajax request query param string
 * @returns {GQLMetadata | undefined}
 */
function parseGQL({
  body,
  query
} = {}) {
  if (!body && !query) return;
  try {
    const gqlBody = parseBatchGQL(parseGQLContents(body));
    if (gqlBody) return gqlBody;
    const gqlQuery = parseSingleGQL(parseGQLQueryString(query));
    if (gqlQuery) return gqlQuery;
  } catch (err) {
    // parsing failed, return undefined
  }
}

/**
 * @param {string|Object} gql The GraphQL object body sent to a GQL server
 * @returns {GQLMetadata}
 */
function parseSingleGQL(contents) {
  if (typeof contents !== 'object' || !contents.query || typeof contents.query !== 'string') return;

  /** parses gql query string and returns [fullmatch, type match, name match] */
  const matches = contents.query.trim().match(/^(query|mutation|subscription)\s?(\w*)/);
  const operationType = matches?.[1];
  if (!operationType) return;
  const operationName = contents.operationName || matches?.[2] || 'Anonymous';
  return {
    operationName,
    // the operation name of the indiv query
    operationType,
    // query, mutation, or subscription,
    operationFramework: 'GraphQL'
  };
}
function parseBatchGQL(contents) {
  if (!contents) return;
  if (!Array.isArray(contents)) contents = [contents];
  const opNames = [];
  const opTypes = [];
  for (let content of contents) {
    const operation = parseSingleGQL(content);
    if (!operation) continue;
    opNames.push(operation.operationName);
    opTypes.push(operation.operationType);
  }
  if (!opTypes.length) return;
  return {
    operationName: opNames.join(','),
    // the operation name of the indiv query -- joined by ',' for batched results
    operationType: opTypes.join(','),
    // query, mutation, or subscription -- joined by ',' for batched results
    operationFramework: 'GraphQL'
  };
}
function parseGQLContents(gqlContents) {
  let contents;
  if (!gqlContents || typeof gqlContents !== 'string' && typeof gqlContents !== 'object') return;else if (typeof gqlContents === 'string') contents = JSON.parse(gqlContents);else contents = gqlContents;
  if (!(0,type_check/* isPureObject */.S)(contents) && !Array.isArray(contents)) return;
  let isValid = false;
  if (Array.isArray(contents)) isValid = contents.some(x => validateGQLObject(x));else isValid = validateGQLObject(contents);
  if (!isValid) return;
  return contents;
}
function parseGQLQueryString(gqlQueryString) {
  if (!gqlQueryString || typeof gqlQueryString !== 'string') return;
  const params = new URLSearchParams(gqlQueryString);
  return parseGQLContents(Object.fromEntries(params));
}
function validateGQLObject(obj) {
  return !(typeof obj !== 'object' || !obj.query || typeof obj.query !== 'string');
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/serialize/bel-serializer.js
var bel_serializer = __webpack_require__(6834);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/ajax/aggregate/index.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */









class Aggregate extends aggregate_base/* AggregateBase */.m {
  static featureName = constants/* FEATURE_NAME */.t;
  constructor(agentRef) {
    super(agentRef, constants/* FEATURE_NAME */.t);
    (0,deny_list/* setDenyList */.R2)(agentRef.runtime.denyList);
    this.underSpaEvents = {};
    const classThis = this;

    // --- v Used by old spa feature
    this.ee.on('interactionDone', (interaction, wasSaved) => {
      if (!this.underSpaEvents[interaction.id]) return;
      if (!wasSaved) {
        // if the ixn was saved, then its ajax reqs are part of the payload whereas if it was discarded, it should still be harvested in the ajax feature itself
        this.underSpaEvents[interaction.id].forEach(item => this.events.add(item));
      }
      delete this.underSpaEvents[interaction.id];
    });
    // --- ^
    // --- v Used by new soft nav
    (0,register_handler/* registerHandler */.X)('returnAjax', event => this.events.add(event), this.featureName, this.ee);
    // --- ^
    (0,register_handler/* registerHandler */.X)('xhr', function () {
      // the EE-drain system not only switches "this" but also passes a new EventContext with info. Should consider platform refactor to another system which passes a mutable context around separately and predictably to avoid problems like this.
      classThis.storeXhr(...arguments, this); // this switches the context back to the class instance while passing the NR context as an argument -- see "ctx" in storeXhr
    }, this.featureName, this.ee);
    this.waitForFlags([]).then(() => this.drain());
  }
  storeXhr(params, metrics, startTime, endTime, type, ctx) {
    metrics.time = startTime;

    // send to session traces
    let hash;
    if (params.cat) {
      hash = (0,stringify/* stringify */.P)([params.status, params.cat]);
    } else {
      hash = (0,stringify/* stringify */.P)([params.status, params.host, params.pathname]);
    }
    const shouldCollect = (0,deny_list/* shouldCollectEvent */.zR)(params);
    const shouldOmitAjaxMetrics = this.agentRef.init.feature_flags?.includes('ajax_metrics_deny_list');
    const jserrorsInUse = Boolean(this.agentRef.features?.[features/* FEATURE_NAMES.jserrors */.DT.jserrors]);

    // Report ajax timeslice metric (to be harvested by jserrors feature, but only if it's running).
    if (jserrorsInUse && (shouldCollect || !shouldOmitAjaxMetrics)) {
      this.agentRef.sharedAggregator.add(['xhr', hash, params, metrics]);
    }
    if (!shouldCollect) {
      if (params.hostname === this.agentRef.info.errorBeacon || this.agentRef.init.proxy?.beacon && params.hostname === this.agentRef.init.proxy.beacon) {
        // This doesn't make a distinction if the same-domain request is going to a different port or path...
        this.reportSupportabilityMetric('Ajax/Events/Excluded/Agent');
        if (shouldOmitAjaxMetrics) this.reportSupportabilityMetric('Ajax/Metrics/Excluded/Agent');
      } else {
        this.reportSupportabilityMetric('Ajax/Events/Excluded/App');
        if (shouldOmitAjaxMetrics) this.reportSupportabilityMetric('Ajax/Metrics/Excluded/App');
      }
      return; // do not send this ajax as an event
    }
    (0,handle/* handle */.p)('bstXhrAgg', ['xhr', hash, params, metrics], undefined, features/* FEATURE_NAMES.sessionTrace */.DT.sessionTrace, this.ee); // have trace feature harvest AjaxNode

    const event = {
      method: params.method,
      status: params.status,
      domain: params.host,
      path: params.pathname,
      requestSize: metrics.txSize,
      responseSize: metrics.rxSize,
      type,
      startTime,
      endTime,
      callbackDuration: metrics.cbTime
    };
    if (ctx.dt) {
      event.spanId = ctx.dt.spanId;
      event.traceId = ctx.dt.traceId;
      event.spanTimestamp = Math.floor(this.agentRef.runtime.timeKeeper.correctAbsoluteTimestamp(ctx.dt.timestamp));
    }

    // parsed from the AJAX body, looking for operationName param & parsing query for operationType
    event.gql = params.gql = parseGQL({
      body: ctx.body,
      query: ctx.parsedOrigin?.search
    });
    if (event.gql) this.reportSupportabilityMetric('Ajax/Events/GraphQL/Bytes-Added', (0,stringify/* stringify */.P)(event.gql).length);
    const softNavInUse = Boolean(this.agentRef.features?.[features/* FEATURE_NAMES.softNav */.DT.softNav]);
    if (softNavInUse) {
      // For newer soft nav (when running), pass the event to it for evaluation -- either part of an interaction or is given back
      (0,handle/* handle */.p)('ajax', [event], undefined, features/* FEATURE_NAMES.softNav */.DT.softNav, this.ee);
    } else if (ctx.spaNode) {
      // For old spa (when running), if the ajax happened inside an interaction, hold it until the interaction finishes
      const interactionId = ctx.spaNode.interaction.id;
      this.underSpaEvents[interactionId] ??= [];
      this.underSpaEvents[interactionId].push(event);
    } else {
      this.events.add(event);
    }
  }
  serializer(eventBuffer) {
    const addString = (0,bel_serializer/* getAddStringContext */.FX)(this.agentIdentifier);
    let payload = 'bel.7;';
    for (let i = 0; i < eventBuffer.length; i++) {
      const event = eventBuffer[i];
      const fields = [(0,bel_serializer/* numeric */.uR)(event.startTime), (0,bel_serializer/* numeric */.uR)(event.endTime - event.startTime), (0,bel_serializer/* numeric */.uR)(0),
      // callbackEnd
      (0,bel_serializer/* numeric */.uR)(0),
      // no callbackDuration for non-SPA events
      addString(event.method), (0,bel_serializer/* numeric */.uR)(event.status), addString(event.domain), addString(event.path), (0,bel_serializer/* numeric */.uR)(event.requestSize), (0,bel_serializer/* numeric */.uR)(event.responseSize), event.type === 'fetch' ? 1 : '', addString(0),
      // nodeId
      (0,bel_serializer/* nullable */.AG)(event.spanId, addString, true) +
      // guid
      (0,bel_serializer/* nullable */.AG)(event.traceId, addString, true) +
      // traceId
      (0,bel_serializer/* nullable */.AG)(event.spanTimestamp, bel_serializer/* numeric */.uR, false) // timestamp
      ];
      let insert = '2,';

      // Since configuration objects (like info) are created new each time they are set, we have to grab the current pointer to the attr object here.
      const jsAttributes = this.agentRef.info.jsAttributes;

      // add custom attributes
      // gql decorators are added as custom attributes to alleviate need for new BEL schema
      const attrParts = (0,bel_serializer/* addCustomAttributes */.n1)({
        ...(jsAttributes || {}),
        ...(event.gql || {})
      }, addString);
      fields.unshift((0,bel_serializer/* numeric */.uR)(attrParts.length));
      insert += fields.join(',');
      if (attrParts && attrParts.length > 0) {
        insert += ';' + attrParts.join(';');
      }
      if (i + 1 < eventBuffer.length) insert += ';';
      payload += insert;
    }
    return payload;
  }
}

/***/ })

}]);